import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom'; // Se estiver usando React Router

const ConfirmationPage = () => {
  const navigate = useNavigate(); // Se React Router estiver configurado

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        textAlign: 'center',
      }}
    >
      <Typography
        variant="h4"
        sx={{ fontWeight: 'bold', marginBottom: 2, color: '#1A7B30' }}
      >
        Obrigado por entrar em contato!
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: 4 }}>
        A equipe do <strong>Thiago Obras</strong> recebeu sua mensagem e entrará em contato com você assim que possível.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/')} // Redireciona para a página inicial
        sx={{
          backgroundColor: '#1A7B30',
          color: '#fff',
          fontWeight: 'bold',
          ':hover': { backgroundColor: '#145A22' },
        }}
      >
        Voltar à Página Inicial
      </Button>
    </Box>
  );
};

export default ConfirmationPage;